/**
 * Helper: Variable
 * -----------------------------------------------------------------------------
 * Retrieve variable from theme strings.
 *
 * @param {String} path - Path to variable stored in `theme-variables.liquid`,
 * excluding cnvs, for example `routes.cart.add` returns `cnvs.routes.cart.add`.
 * @returns {*}
 *
 */
export default (path) => {
  try {
    let variable = cnvs;

    path.split('.').forEach((part) => {
      variable = variable[part];
    });

    return variable;
  } catch (error) {
    window.console.error(`Unable to resolve variable cnvs.${path}`);
    window.console.error(error);
    return null;
  }
};
